import React, { useEffect, useRef, useState } from 'react';
import UploadFile from '../../../components/Request/UploadFile';
import cx from 'classnames';
import {
  getCurrentPage,
  requestsSelector,
  setCurrentRequestFilesSize,
  setLoading,
  setNextButtonEnabled,
  setRequestData,
  updateRequestPages,
} from '../../../redux/slicers/requestSlicer';
import { useDispatch, useSelector } from 'react-redux';
import styles from './FullProduct.module.scss';
import { getFileFormData, setDefaultFiles, uploadRequestFile } from './helper';
import {
  apiDeleteRequestFile,
  apiGetRequestImages,
  apiPostImageOnPresignedData,
} from '../../../helpers/api';
import { Image, Loader } from '../../../common';
import icons from '../../../assets';
import { download } from '../../../common/DownloadFileController/downloadFile';

function FullProduct({ className, isReadOnly }) {
  const { DownloadIcon, RequestDeleteIcon } = icons;
  const _requestSelector = useSelector(requestsSelector);
  const currentPage = useSelector(getCurrentPage);
  const [data, setData] = useState({});
  const [imageLoading, setImageLoading] = useState(false);
  const dispatch = useDispatch();
  const dataRef = useRef({});

  const FIELDS = ['Front', 'Side', 'Back', 'Top'];

  const handleFileChange = async (_file, _title = '') => {
    if (isReadOnly) return;
    setImageLoading(true);
    try {
      // Guard: if drag-drop sends an array, always use only the first file
      if (Array.isArray(_file)) {
        if (_file.length === 0) return;
        _file = _file[0];
      }
      if (!_file || !(_file instanceof File || _file instanceof Blob)) return;

      const imageUrl = URL.createObjectURL(_file);
      const _data = {};

      _data[_title] = { file: _file, thumbnail: imageUrl, url: imageUrl, isNew: true };
      if (dataRef.current[_title]?.id) await apiDeleteRequestFile(dataRef.current[_title]?.id);
      setData({ ...dataRef.current, ..._data });
      dataRef.current = { ...dataRef.current, ..._data };

      await uploadFullProductImage({ fileData: _data[_title], fileType: _title });

      dispatch(setRequestData({ ...dataRef.current, ..._data }));
    } catch (error) {
      console.error('FullProduct handleFileChange error:', error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleDownloadClick = async (e, _file) => {
    e.stopPropagation();
    await download({ fileUrl: _file.url, fileName: _file.filename });
  };

  useEffect(async () => {
    if (_requestSelector?.currentRequestId)
      {
        await setDefaultFiles(_requestSelector.currentRequestId, 'productImages', setData, true);
        dispatch(setNextButtonEnabled(true)); 
      }
  }, []);

  useEffect(() => {
    if (!Object.keys(dataRef.current)?.length)
      dataRef.current = data
  }, [data])


  const uploadFullProductImage = async ({ fileData, fileType }) => {

    const formData = new FormData();
    formData.append('three_d_model_request', _requestSelector.currentRequestId);
    formData.append('file_type', "productImages");
    formData.append('view_type', fileType);
    formData.append('file_name', fileData.file.name);
    formData.append('file_size', fileData.file.size);

    dispatch(setLoading(true));

    const updatedData = await uploadRequestFile(
      formData,
      [fileData.file],
      null,
      null,
      '',
      false,
      dispatch,
      _requestSelector
    );

    dataRef.current[fileType] = {...dataRef.current[fileType], id: updatedData[0].id}
    setData(dataRef.current)

    await Promise.all(updatedData.map(
      async (_file) => await apiPostImageOnPresignedData(_file.file, _file.presigned_data_file)
    ));

    dispatch(setLoading(false));
  }

  useEffect(() => {
    if (isReadOnly) return;
    dispatch(setRequestData(''));
  }, []);

  const handleFileRemove = async (e, item) => {
    e.stopPropagation();
    setImageLoading(true)
    const _data = { ...data };
    if (data[item]?.id) {
      dispatch(
        setCurrentRequestFilesSize(_requestSelector.currentRequestFilesSize - data[item].file.size)
      );
      await apiDeleteRequestFile(data[item].id);
    } else {
      const res = await setDefaultFiles(_requestSelector.currentRequestId, 'productImages', setData, true);
      if (res?.[item]?.id) {
        dispatch(
          setCurrentRequestFilesSize(+_requestSelector.currentRequestFilesSize - +res[item]?.file?.size)
        );
        await apiDeleteRequestFile(res[item]?.id);
      }
    }
    delete _data[item];
    setData(_data);
    dataRef.current = _data;
    setImageLoading(false)
  };

  useEffect(() => {
    if (Object.keys(data).length === 4) {
      dispatch(
        updateRequestPages({
          ...currentPage,
          isCompleted: true,
        })
      );
    }
  }, [data]);

  return (
    <div className={cx('d-flex justify-content-between flex-wrap', className)} readOnly>
      <Loader
        loading={imageLoading}
        style={{ position: 'fixed', height: '100vh', background: '#00000096', zIndex: '123' }}
      />
      {FIELDS.map((item) => (
        <>
          <UploadFile
            id={item}
            title={item}
            className={cx(
              styles.uploadFileWrapper,
              'position-relative',
              isReadOnly && !data[item]?.url && styles.disabled
            )}
            acceptMutipleFiles={false}
            onFileChange={handleFileChange}
            uploadText={isReadOnly && 'No images added'}
            hideSubtitle
            defaultData={data || currentPage.data}
            style={isReadOnly ? { height: '300px', marginBottom: '1rem' } : {}}
            subClassName={cx(
              !isReadOnly ? styles.heightFourHundread : styles.heightThreehundread,
              data[item]?.url && styles.lightGraybg
            )}>
            {data[item]?.url && (
              <>
                {/* <img
                  src={data[item]?.url}
                  className={styles.image}
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                    height: isReadOnly ? '250px' : '350px',
                    padding: isReadOnly ? '1rem' : '0',
                    paddingTop: isReadOnly ? '1rem' : '1.5rem',
                  }}
                  loading="lazy"
                /> */}

                <Image
                  src={data[item]?.url}
                  containerProps={{ className: styles.imageRoot }}
                  placeholderWhileLoading
                  ratio={0}
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                    height: isReadOnly ? '250px' : '350px',
                    paddingTop: '1rem',
                    objectFit: 'contain',
                  }}
                  rounded={false}
                />
                <div className={styles.titleBar}>
                  <div
                    className="p-1"
                    style={{
                      height: '50px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '90%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'no-wrap',
                    }}
                    data-toggle="tooltip"
                    data-placement="top"
                    title={data[item].file.name}>
                    {data[item].file.name}
                  </div>
                  <div
                    onClick={(e) => handleDownloadClick(e, data[item])}
                    className={styles.svgWrapper}>
                    {' '}
                    <DownloadIcon />
                  </div>
                </div>
                {!isReadOnly ? (
                  <div onClick={(e) => handleFileRemove(e, item)} className={styles.deleteIcon}>
                    <RequestDeleteIcon />
                  </div>
                ) : null}
              </>
            )}
          </UploadFile>
        </>
      ))}
    </div>
  );
}

export default FullProduct;
